/* Minimal GLB reader for our own exports (tools/3mf2glb.mjs, optionally tools/glb-quantize.mjs): indexed meshes. Shopify assets are flat, so three.js sits next to this file. */
import * as THREE from './three.module.min.js';

export async function loadGLB(url, materials) {
  const res = await fetch(url, { mode: 'cors' });
  if (!res.ok) throw new Error('GLB ' + res.status + ' ' + url);
  const buf = await res.arrayBuffer();
  const dv = new DataView(buf);
  const jsonLen = dv.getUint32(12, true);
  const json = JSON.parse(new TextDecoder().decode(new Uint8Array(buf, 20, jsonLen)));
  const binStart = 20 + jsonLen + 8;
  /* quantized exports (tools/glb-quantize.mjs): positions int16 + extras.q {min,max}, normals int8 normalized → decoded to floats once */
  const T = { 5126: Float32Array, 5125: Uint32Array, 5123: Uint16Array, 5122: Int16Array, 5120: Int8Array };
  const arr = i => {
    const a = json.accessors[i], v = json.bufferViews[a.bufferView], n = a.count * (a.type === 'VEC3' ? 3 : 1);
    const raw = new T[a.componentType](buf, binStart + (v.byteOffset || 0), n);
    if (a.componentType === 5122 && a.extras?.q) {
      const { min, max } = a.extras.q, f = new Float32Array(n);
      for (let k = 0; k < n; k++) { const c = k % 3; f[k] = min[c] + ((raw[k] + 32767) / 65534) * (max[c] - min[c]); }
      return f;
    }
    if (a.componentType === 5120) { const f = new Float32Array(n); for (let k = 0; k < n; k++) f[k] = raw[k] / 127; return f; }
    return raw;
  };
  const build = ni => {
    const n = json.nodes[ni];
    if (n.mesh !== undefined) {
      const p = json.meshes[n.mesh].primitives[0], g = new THREE.BufferGeometry();
      g.setAttribute('position', new THREE.BufferAttribute(arr(p.attributes.POSITION), 3));
      g.setAttribute('normal', new THREE.BufferAttribute(arr(p.attributes.NORMAL), 3));
      if (p.attributes._WEIGHT !== undefined) g.setAttribute('weight', new THREE.BufferAttribute(arr(p.attributes._WEIGHT), 1));
      g.setIndex(new THREE.BufferAttribute(arr(p.indices), 1));
      g.computeBoundingBox();
      const key = n.extras?.material || 'black';
      const m = new THREE.Mesh(g, materials[key] || materials.black);
      m.name = n.name; m.userData.material = key;
      return m;
    }
    const grp = new THREE.Group(); grp.name = n.name;
    (n.children || []).forEach(c => grp.add(build(c)));
    return grp;
  };
  return build(json.scenes[0].nodes[0]);
}
